import React from 'react';
import './styles/sidebar.style.scss';
import LinkList from './components/linkList.component';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { RouteEnum } from 'src/_shared/routes';
import { ReactComponent as Logo } from 'src/_shared/assets/svg/logo.svg';
export interface ISideBarProps {
    isLogged?: boolean;
    isIDEOpen?: boolean;
    currentRoute?: string;
}

class SideBar extends React.Component<ISideBarProps> {
    render() {
        return (
            <div className='sidebar-container'>
                <div className='sidebar-logo-wrapper'>
                    <a className='sidebar-logo' onClick={() => NavigationManager.getInstance().navigateTo(RouteEnum.home)}>
                        <Logo width={138} height={68} />
                    </a>
                </div>
                <div className='sidebar-divider' />
                <LinkList isIDEOpen={this.props.isIDEOpen as boolean} route={this.props.currentRoute as string} />
                <div className='sidebar-footer'>
                    <span className='sidebar-footer-text'>v1.0</span>
                </div>
            </div>
        );
    }
}

export default SideBar;
